



















































import Vue from 'vue'
import {
  Component, Prop, Emit,
} from 'vue-property-decorator';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import ModalComponent from '@/shared/modal/modal.component.vue'
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import ModalOptions from '@/shared/modal/modal-options.entity';
import ContractGroupService from '@/domain/contract/service/contract-group.service';
import Rules from '@/shared/rules/rules';
import validateCNPJ, { alphanumericCnpj } from '@/shared/utils/cnpj';
import ContractGroup from '@/domain/contract/entity/contract-group.entity';

@Component({
  components: {
    ModalComponent,
    ModalWarning,
    VbTooltipSlot,
    LabelSlot,
  },
})
export default class ConnectContractToContractGroup extends Vue {
  @Prop({ required: true })
  show!: boolean;

  @Prop({ required: true })
  businessUnitId!: string;

  @Prop({
    required: true,
  })
  contractGroup!: ContractGroup;

  showConfirmDialog: boolean = false;

  warningMessage: string = 'O CNPJ informado já está vinculado a outro Grupo. '
    + 'Deseja utilizar o mesmo CNPJ para criar um novo Grupo de Contratos?';

  @Emit('cancel')
  cancel(): void {}

  get options(): ModalOptions {
    return {
      title: 'Editar Grupo de Contratos',
      titleAlign: 'center',
      showClose: false,
      showOk: true,
      loadingOk: false,
      labelOk: 'Salvar',
      okColor: 'bluePrimary',
      showCancel: true,
      labelCancel: 'Cancelar',
      width: 550,
      persistent: true,
    }
  }

  private valid: boolean = false;

  private rules: Rules = new Rules();

  async handleConfirm() {
    if (this.contractGroup.name.toString().trim() === '') {
      VbSnackbarService.showError('Informe o Nome do Grupo de Contrato!');
      return;
    }

    const cnpj = alphanumericCnpj(this.contractGroup.cnpj);
    if (cnpj === '') {
      VbSnackbarService.showError('Informe o Número do documento do Grupo de Contrato!');
      return;
    }

    if (cnpj.length === 14 && !validateCNPJ(cnpj)) {
      VbSnackbarService.showError('Informe um CNPJ válido!');
      return;
    }

    if (await this.hasCnpjContractGroup()) {
      this.showConfirmDialog = true;
    } else {
      this.handleEditContractGroup();
    }
  }

  resetValidation() {
    this.showConfirmDialog = false;
  }

  confirmUseDuplicateCnpj() {
    if (!this.handleEditContractGroup()) {
      VbSnackbarService.showError('Erro ao tentar editar um novo Grupo de Contrato!');
    }
  }

  async hasCnpjContractGroup(): Promise<boolean> {
    this.options.loadingOk = true;
    return ContractGroupService.hasCnpjContractGroupEdit(
      this.businessUnitId,
      alphanumericCnpj(this.contractGroup.cnpj),
      this.contractGroup.id,
    )
      .then((response: any) => response.success === false)
      .catch((error: any) => {
        VbSnackbarService.handleHttpError(error);
        return false;
      })
      .finally(() => {
        this.options.loadingOk = false;
      });
  }

  async handleEditContractGroup() {
    this.options.loadingOk = true;
    ContractGroupService.editContractGroup(
      this.contractGroup.id,
      this.contractGroup.name,
      this.contractGroup.customerName,
      alphanumericCnpj(this.contractGroup.cnpj),
    )
      .then((response: any) => {
        if (response.status === 400) {
          VbSnackbarService.showError(response.messages[0]);
        }
        if (response === '' || response.status === 200) {
          VbSnackbarService.showSuccess('Grupo de Contratos editado com sucesso!');
          this.resetValidation();
          this.$emit('ok');
        }
      })
      .catch(() => VbSnackbarService.showError('Erro ao editar o Grupo de Contratos!'))
      .finally(() => {
        this.options.loadingOk = false;
      });
  }
}
